export default __webpack_public_path__ + "static/media/HT.1ac85026.svg";